module.exports = __webpack_public_path__ + "static/media/shot-beekeeper-beekeeping-suit-standing-near-row-beehives-his-apiary-copyspace.e553f6e5.jpg";